import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Country, County, State } from 'src/app/models/case/case.interface';
import { PaginatedData, PaginatedDataResponse } from 'src/app/models/common/common.interface';
import { CaseService } from 'src/app/services/case.service';
import { LocationService } from 'src/app/services/location.service';

@Component({
  selector: 'app-location-detail',
  templateUrl: './location-detail.component.html',
  styleUrls: ['./location-detail.component.css']
})
export class LocationDetailComponent implements OnInit, OnChanges {
  @Output() formSubmitted: EventEmitter<boolean> = new EventEmitter<boolean>();
  locationDetailForm: FormGroup;
  locationData = [];
  countries$: Observable<Country[]>;
  states$: Observable<State[]>;
  counties$: Observable<Country[]>;
  @Input() location = null;
  @Input() editLocationIndex:number = null;
  unsubscribe$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private caseService: CaseService,
    private locationService : LocationService,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.initForm();
    this.countries$ = this.countries();
    this.states$ = this.states();
    this.locationData = this.caseService.caseDataValue.location_detail || [];
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['location'] && changes['location']?.currentValue && this.locationDetailForm) {
      this.prefillLocationForm(changes['location']?.currentValue);
      this.editLocationIndex = changes['editLocationIndex']?.currentValue;
    }
  }

  prefillLocationForm(location) {
    this.locationDetailForm.patchValue({
      address_line_1: location?.address_line || '',
      city: location?.city || '',
      zip: location?.zip || '',
      country: location?.country || '',
      state: location?.state || '',
      county: location?.county || '',
    });
  }

  initForm() {
    this.locationDetailForm = this.fb.group({
      address_line_1: ['', [Validators.required]],
      city: ['', []],
      zip: ['', []],
      country: ['', []],
      state: ['', []],
      county: ['', []],
    });
  }

  onSubmitForm() {
    // if(this.saveLocation(true) === false){
    //   return;
    // }

    console.log(this.locationDetailForm.value);


    const caseId = this.caseService.caseDataValue?.saved_case_data?.case.id;
    const reqBody = {
      addresses: this.locationData
    }

    this.caseService.createCaseLocationInformation(caseId,reqBody)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(
      (res) => {
        this.toastr.success(res?.details?.message);
        this.formSubmitted.emit(true);
        this.caseService.setCaseData({
          ...this.caseService.caseDataValue,
          saved_case_data: res?.details?.data,
        });

        this.locationDetailForm.reset();
        this.editLocationIndex = null;
        this.location = null;
      },
      ({ error }: HttpErrorResponse) => {
        this.toastr.error(error?.errors[0]);
      }
    );
  }

  addNewLocation(){
    this.editLocationIndex = null;
    this.location = null;
    this.locationDetailForm.reset();
  }

  saveLocation(isSubmit = false){
    if(this.locationDetailForm.invalid){
      this.locationDetailForm.markAllAsTouched();
      return false;
    }

    if(this.editLocationIndex !== null && this.editLocationIndex !== undefined){
      this.locationData[this.editLocationIndex] = this.locationDetailForm.value;
    }else{
      this.locationData.push(this.locationDetailForm.value);
    }

    this.caseService.setCaseData({
      ...this.caseService.caseDataValue,
      location_detail: this.locationData
    });

    if(!isSubmit){
      this.locationDetailForm.reset();
      this.editLocationIndex = null;
      this.location = null;
    }

  }

  countries = () : Observable<Country[]> => {
    return this.locationService
      .getCountries(
        10,
        1
      )
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<Country>>) =>
            res?.details?.hits || []
        )
      );
  }

  states = () : Observable<State[]> => {
    return this.locationService
      .getStates(
        10,
        1
      )
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<State>>) =>
            res?.details?.hits || []
        )
      );
  }

  counties = () : Observable<County[]> => {
    return this.locationService
      .getCounties(
        10,
        1,
        this.locationDetailForm.get('state').value ? JSON.parse(this.locationDetailForm.get('state').value).id : null
      )
      .pipe(
        map(
          (res: PaginatedDataResponse<PaginatedData<Country>>) =>
            res?.details?.hits || []
        )
      );
  }

  jsonStringify(data){
    return JSON.stringify(data);
  }

  onChangeCountry(){
    this.locationDetailForm.get('state').setValue('');
    this.locationDetailForm.get('county').setValue('');
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

  }
}
